module.exports = __webpack_public_path__ + "img/badge-discount.57aa88e5.svg";